var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M6.008.784c2.898 0 5.249 2.099 5.25 4.685 0 1.402-.694 2.658-1.789 3.516l.24 1.624a.19.19 0 0 1-.277.195l-1.688-.915a5.7 5.7 0 0 1-1.736.27c-2.899 0-5.25-2.097-5.25-4.688S3.109.784 6.008.784M8.667 8.67l.34-.27.005.004c.952-.75 1.5-1.819 1.5-2.929 0-2.171-2.018-3.937-4.5-3.937s-4.5 1.766-4.5 3.937 2.017 3.938 4.5 3.938a5.1 5.1 0 0 0 1.51-.233l.305-.094.277.15.701.379-.075-.514zM5.5 5.599a.507.507 0 0 1 .506-.506c.274 0 .503.228.507.506a.514.514 0 0 1-.507.506.51.51 0 0 1-.506-.506m2.648-.506a.507.507 0 0 0 0 1.012.514.514 0 0 0 .506-.506.514.514 0 0 0-.506-.506m-4.788.506a.507.507 0 0 1 .506-.506c.274 0 .503.228.506.506a.514.514 0 0 1-.506.506.51.51 0 0 1-.506-.506",
    clipRule: "evenodd"
  })));
};
export default SvgComment;